import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import Heading from "@amzn/meridian/heading";
import Column from "@amzn/meridian/column";

/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @return JSX.Element
 */

const PageHeader = ({head, headAlt, desc, descAlt}) => {
    return (
        <Column spacing={"none"}>
            <Heading level={2} type="h400" alignment="left">
                <FormattedMessage id={head} defaultMessage={headAlt}/>
            </Heading>
            <Text color={"secondary"}><FormattedMessage id={desc} defaultMessage={descAlt}/></Text>
        </Column>
    )
}

PageHeader.propTypes = {
    head: PropTypes.string,
    headAlt: PropTypes.string,
    desc: PropTypes.string,
    descAlt: PropTypes.string,
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/util/PageHeader.js